import { ReactElement } from 'react';

import { Button, ButtonVariant, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { translationKeys } from '../../../translations';

type BookAppointmentButtonProps = {
   readonly entryId: number;
   readonly patientId: number;
   readonly practitionerId: number;
};

export const BookAppointmentButton = (props: BookAppointmentButtonProps): ReactElement => {
   const push = useHistoryPushWithBackAction(true);

   const handleClick = (): void => {
      push(
         visitPaths.getCalendarPath({
            searchParams: {
               bookPatientId: props.patientId,
               practitionerId: props.practitionerId,
               waitlistEntryId: props.entryId,
            },
         }),
         {
            label: translationKeys.goBackToWaitlist,
         }
      );
   };

   return (
      <Button
         label={translationKeys.bookAppointment}
         onClick={handleClick}
         variant={ButtonVariant.SECONDARY}
         compact
         testId={'bookAppointment'}
      />
   );
};
